export const FETCH_SKUS_COMPACT_REQUEST = '@sku/FETCH_SKUS_COMPACT_REQUEST';
export const FETCH_SKUS_COMPACT_SUCCESS = '@sku/FETCH_SKUS_COMPACT_SUCCESS';
export const FETCH_SKUS_COMPACT_FAILED = '@sku/FETCH_SKUS_COMPACT_FAILED';
